var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-chat-component p-5" }, [
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.chat.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("setting.chat.explain"))),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c("label", { staticClass: "room-setting-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isChatMode,
                expression: "isChatMode",
              },
            ],
            staticClass: "room-setting-radio",
            attrs: { type: "checkbox", name: "useChat" },
            domProps: {
              checked: Array.isArray(_vm.isChatMode)
                ? _vm._i(_vm.isChatMode, null) > -1
                : _vm.isChatMode,
            },
            on: {
              click: function ($event) {
                return _vm.CHANGE_SETTING_DATA({
                  type: "useChat",
                  value: !_vm.isChatMode,
                })
              },
              change: function ($event) {
                var $$a = _vm.isChatMode,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isChatMode = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isChatMode = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isChatMode = $$c
                }
              },
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("setting.chat.use")))]),
        ]),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass: "room-setting-content-box opacity-40 pointer-events-none",
      },
      [
        _c("h6", { staticClass: "room-setting-content-title" }, [
          _vm._v(_vm._s(_vm.$t("setting.chat.participantList.title"))),
        ]),
        _c("div", { staticClass: "room-setting-content-text-box" }, [
          _c("p", { staticClass: "room-setting-content-text" }, [
            _vm._v(_vm._s(_vm.$t("setting.chat.participantList.description"))),
          ]),
        ]),
        _c("div", { staticClass: "room-setting-input-box" }, [
          _c(
            "label",
            { staticClass: "room-setting-label" },
            [
              _c("GrmSimpleSelect", {
                attrs: {
                  value: _vm.participantListRoleId,
                  options: [
                    {
                      value: "participant",
                      title: this.$t(
                        "setting.chat.participantList.select.participant"
                      ),
                    },
                    {
                      value: "speaker",
                      title: this.$t(
                        "setting.chat.participantList.select.speaker"
                      ),
                    },
                    {
                      value: "emcee",
                      title: this.$t(
                        "setting.chat.participantList.select.emcee"
                      ),
                    },
                  ],
                },
                on: { input: _vm.onChangeParticipantListRoleId },
              }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }